
























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class AppBarcode extends Vue {
  isLoading:boolean = true;
  installRequired:boolean = false;
  isIos:boolean = false;
  isAndroid:boolean = false;  
  created(){
    //mfa認証回避フラグ
    this.$api.bypassMfa = true;
    //api.tsでコンポーネントロードを回避(なんとなく)
    var router = this.$router;
    this.$api.handleMfaException = function(mode: Common.mfaFlags) {
        this.launchDialog(Components.Mfa, router, {'mode': mode}, document.body);  
    };    
    //ログイン処理とマスタ初期化が完了したら画面を描画する
    this.$api.initialize().then(() => {
        this.isLoading = false;    

        var resizeHandler = ()=>{
          this.$api.spMode = window.outerWidth < 1280 ? true : false;    //1280px以下をspModeとし、bodyにcx_spmodeを追加する              
          // this.userDescription = window.outerWidth > 1450 ? this.$api.auth.userId: null;
          // this.operationDescription = window.outerWidth > 1450 || this.$api.spMode  ? '運用情報': null;      
          document.documentElement.style.setProperty('--vh', (window.innerHeight - 40) + 'px'); //レイアウト調整

          this.$api.innerHeight = window.innerHeight;
        };

        resizeHandler();
        window.addEventListener('resize',resizeHandler);        

        this.isIos = /iPhone|iPad|iPod/.test(navigator.userAgent);
        this.isAndroid = /android/i.test(navigator.userAgent);
        var isStandaloneMode = window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone == true;
        if ((this.isIos || this.isAndroid) && isStandaloneMode == false) this.installRequired = true;

    });    
  }
  onRefresh(){
    location.reload();
  }
  onLogout(){
    this.$api.auth.logout();
  }
  onHome(){
    this.$router.push("/barcode")
  }
  // 設定画面を開いた状態で設定のアイコンを押すと元の画面に戻るようにする
  onSetting(){
    this.$router.push("/barcode/setting")
  }
}
